import { AbsenceType } from '@lmt/shared-types';
import { SelectedResources } from '@lmt/unicorn-shared/app/components/calendar/visit/common/types';
import { DateTimeInterval } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/date-time/DateTimeIntervalPicker';

export interface AbsenceCreatingFormData {
  absenceType: AbsenceType;
  title?: string;
  absenceReasonId?: number | null;
  dateTimeInterval: DateTimeInterval;
  resources: SelectedResources;
  note: string;
  acceptConflict: boolean;
}

export enum AbsenceCalendarType {
  Year = 1,
  Month = 2,
}

// we cannot choose resources when create holiday, but we need to show header in resource panel
export const holidayPseudoResourceType = 'Holiday';
